var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYenSign = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M100.2 224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v-22.3zm91.8 64h80c17.7 0 32-14.3 32-32s-14.3-32-32-32h-52.2L192 265.7zm-64 32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80zm64 64h80c17.7 0 32-14.3 32-32s-14.3-32-32-32h-80z",
  style: {
    opacity: 0.4
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M58.6 46.2C48.8 31.5 29 27.6 14.3 37.4S-4.4 67 5.4 81.7l122.6 184V448c0 17.7 14.3 32 32 32s32-14.3 32-32V265.7l122.6-184c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9L160 198.3z",
  className: "yen-sign_svg__fa-primary"
})));
export default SvgYenSign;